import { booleanTickRenderer } from "lib/agGrid/renderers";
import { SideLoadedBusinessActionsRenderer } from "lib/agGrid/renderers/sideLoadedBusinessActionsRenderer";

export const SideLoadedBusinessColId = {
  NAME: "ffe17918-8a30-439d-898a-b26e2ec36e99",
  ABN: "ce7b63f4-fb5d-4ec4-bdb0-240787f542fe",
  USED: "51ac6bcd-8670-4487-9ff3-79aaaebfb22f",
  ACTIONS: "6421925c-2a6b-4508-ae36-0cc873ecbea9",
};

export const SideLoadedBusinessColumnDef = {
  [SideLoadedBusinessColId.NAME]: {
    colId: SideLoadedBusinessColId.NAME,
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 180,
  },
  [SideLoadedBusinessColId.ABN]: {
    colId: SideLoadedBusinessColId.ABN,
    field: "abn",
    headerName: "ABN",
    width: 140,
  },
  [SideLoadedBusinessColId.USED]: {
    colId: SideLoadedBusinessColId.USED,
    field: "isUsed",
    headerName: "Used",
    width: 90,
    cellRenderer: booleanTickRenderer,
  },
  [SideLoadedBusinessColId.ACTIONS]: {
    colId: SideLoadedBusinessColId.ACTIONS,
    headerName: "Actions",
    width: 100,
    pinned: "right",
    cellRenderer: SideLoadedBusinessActionsRenderer,
  },
};
